// Packages:
import { NavLink } from "react-router-dom"
import { useState } from "react"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'

//Typescript:
import { courseDataType } from "../../pages/details"

// Data
import courseModules from '../../data/courseModules.json'

const Services = () => {
    // Constants:
    const bgColorArr = [
        {
            id: 0,
            color: '#FAE0F3'
        },
        {
            id: 1,
            color: '#D0FDE0'

        },
        {
            id: 2,
            color: '#FBFDD1'
        },
        {
            id: 3,
            color: '#DFD4FF'
        },
        {
            id: 4,
            color: '#D0FDE0'
        },
    ]
    // States:
    const [isShowingMoreCourses, setIsShowingMoreCourses] = useState<boolean>(false)

    // Functions:
    const assignBgColor = (index: number) => {
            const rowIndex = Math.floor(index / 5) * 5 // 5 is the number of cards which should be present in a single row in desktop view when show more is true
            return bgColorArr?.[index - rowIndex]?.color
    }

    return <div className='col-[2_/_3] my-[4rem] flex flex-col items-center'>
        <h2 className='text-[30px] md:text-[40px] font-extrabold mb-[40px]'>Our Programs</h2>
        <div className='mt-[20px] w-full'>
        { isShowingMoreCourses ? (
                <div className='grid grid-cols-[repeat(5_,_1fr)] gap-[16px]'>
                    {courseModules?.map((service:courseDataType, index:number)=>
                    <div className='text-center'
                        key={service?.id}>
                        <div className='flex flex-col justify-center items-center rounded-[40px] p-[30px] gap-[25px]' style={{backgroundColor: assignBgColor(index)}}>
                            <img className='object-contain aspect-[120/80]' src={service?.icon} alt='icon'/>
                            <div className='md:basis-[max-content] lg:basis-[140px]'>
                                <h3 className='text-[20px] md:text-[18px] font-bold'>{service?.title}</h3>
                                <p className='text-[14px] mt-[10px]'>{service?.shortDesc} </p>
                            </div>
                            <NavLink to={`/details/${service?.id}`} className='block font-bold text-[14px] rounded-[2rem] bg-[#FF6D28] text-[#F1F8FF] px-[24px] py-[12px]'>Know More</NavLink>
                        </div>
                    </div>)}
                </div>
            ): (<Swiper
                spaceBetween={16}
                slidesPerView={1}
                draggable={true}
                loop={false}
                pagination={{
                    clickable: true
                }}
                modules={[Pagination]}
                breakpoints={{
                    500: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                    },
                    1024: {
                    slidesPerView: 5,
                    spaceBetween: 16,
                    pagination: false,
                    allowTouchMove: false
                },
            }}
            className="mySwiper"
            >
                {courseModules?.map((service:courseDataType, index:number)=>
                    <SwiperSlide className='text-center'
                        key={service?.id}>
                        <div className='flex flex-col justify-center items-center rounded-[40px] p-[30px] gap-[25px]' style={{backgroundColor: assignBgColor(index)}}>
                            <img className='object-contain aspect-[120/80]' src={service?.icon} alt='icon'/>
                            <div className='md:basis-[max-content] lg:basis-[140px]'>
                                <h3 className='text-[20px] md:text-[18px] font-bold'>{service?.title}</h3>
                                <p className='text-[14px] mt-[10px]'>{service?.shortDesc} </p>
                            </div>
                            <NavLink to={`/details/${service?.id}`} className='block font-bold text-[14px] rounded-[2rem] bg-[#FF6D28] text-[#F1F8FF] px-[24px] py-[12px]'>Know More</NavLink>
                        </div>
                </SwiperSlide>)} 
            </Swiper>
        )}
        <div className='mt-[40px] w-max mx-[auto] font-extrabold text-[25px] text-[#FF6D28] cursor-pointer hidden lg:block' onClick={()=>setIsShowingMoreCourses(!isShowingMoreCourses)}>
            {isShowingMoreCourses ? 'Show less' : 'Show more'}
        </div>
        </div>
    </div>
}

export default Services